import { render, staticRenderFns } from "./StudentDataForms.vue?vue&type=template&id=450fdbe1&"
import script from "./StudentDataForms.vue?vue&type=script&lang=js&"
export * from "./StudentDataForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('450fdbe1')) {
      api.createRecord('450fdbe1', component.options)
    } else {
      api.reload('450fdbe1', component.options)
    }
    module.hot.accept("./StudentDataForms.vue?vue&type=template&id=450fdbe1&", function () {
      api.rerender('450fdbe1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/StudentDataForms.vue"
export default component.exports